import HasToBeAgencyGuard from 'app/core/guards/HasToBeAgencyGuard';
import HasToBeLoggedInGuard from 'app/core/guards/HasToBeLoggedInGuard';
import DefaultLayout from 'app/core/layout/DefaultLayout';
import Error404Page from 'app/main/errors/Error404Page';
import DataLoader from 'app/ui_v2/components/data-loader/DataLoader';
import { lazy, Suspense } from 'react';
import { RouteObject } from 'react-router-dom';

const Projects = lazy(() => import('../../../../main/elevators/agency/projects/Projects'));
const Certificates = lazy(() => import('../../../../main/elevators/certificates/Certificates'));
const ProjectDetails = lazy(() => import('../../../../main/elevators/agency/projects/project-details/ProjectDetails'));
const EquipmentDetails = lazy(() => import('../../../../main/elevators/agency/equipment-details/EquipmentDetails'));
const ReportDetails = lazy(() => import('../../../../main/elevators/agency/report-details/ReportDetails'));
const PaymentRequest = lazy(() => import('../../../../main/elevators/agency/payment-request/PaymentRequest'));
const PaymentRequestView = lazy(() => import('../../../../main/elevators/agency/payment-request/PaymentRequestView'));
const Inspections = lazy(() => import('../../../../main/elevators/agency/inspections/Inspections'));

const PREFIX = '/agency/elevators';

export const agencyElevatorsRoutes: RouteObject[] = [
  {
    path: PREFIX,
    element: (
      <HasToBeLoggedInGuard>
        <HasToBeAgencyGuard>
          <DefaultLayout />
        </HasToBeAgencyGuard>
      </HasToBeLoggedInGuard>
    ),
    errorElement: <Error404Page />,
    children: [
      {
        path: 'projects/:id',
        element: (
          <Suspense fallback={<DataLoader />}>
            <ProjectDetails />
          </Suspense>
        ),
      },
      {
        path: 'equipment/:equipmentId',
        element: (
          <Suspense fallback={<DataLoader />}>
            <EquipmentDetails />
          </Suspense>
        ),
      },
      {
        path: 'projects',
        element: (
          <Suspense fallback={<DataLoader />}>
            <Projects />
          </Suspense>
        ),
      },
      {
        path: 'certificates',
        element: (
          <Suspense fallback={<DataLoader />}>
            <Certificates />
          </Suspense>
        ),
      },
      {
        path: 'Inspections',
        element: (
          <Suspense fallback={<DataLoader />}>
            <Inspections />
          </Suspense>
        ),
      },
      {
        path: 'report/:id',
        element: (
          <Suspense fallback={<DataLoader />}>
            <ReportDetails />
          </Suspense>
        ),
      },
      {
        path: 'projects/:id/payment-request/create',
        element: (
          <Suspense fallback={<DataLoader />}>
            <PaymentRequest />
          </Suspense>
        ),
      },
      {
        path: 'projects/:id/payment-request/:paymentRequestId',
        element: (
          <Suspense fallback={<DataLoader />}>
            <PaymentRequestView />
          </Suspense>
        ),
      },
    ],
  },
];
